import reqwest from 'reqwest'
import Utils from '../lib/utils'
import Cookie from '../lib/Cookie'
import ApiConfig from './apiConfig'
import Events from './events'
import {
  ThemeConfig,
  DefaultLoginOptions
} from './defaultConfig'

let userInfo = null // 用户信息缓存

// 登录成功回调队列
let loginSuccessQueue = []

// 退出登录成功回调队列
let logoutSuccessQueue = []

// 用户数据获取成功回调
let cacheCheckLoginQueue = []

function checkhandle (Queue, handle) {
  Queue.forEach((item, index) => {
    if (item === handle) {
      return true
    }
  })
  return false
}
const Login = {
  isLoginStatus: false,
  checkLoginStatus: false,
  cacheCheckLoginCb: [],
  isLogin: function () {
    if (!__isBrowser__) {
      return
    }
    var gck = decodeURIComponent(Cookie('P_gck') || '').split('|')[1]
    return gck && gck !== 'NA'
  },

  init () {
    if (typeof window !== 'undefined') {
      if (this.isLogin()) {
        this.checkLogin()
      }
      // 加载登录组件
      if (!window.YKLoginLoader) {
        Utils.getScript(ApiConfig.loginSDK, () => {
          this.Xlogin()
        })
      } else {
        this.Xlogin()
      }
    }
  },

  /**
     * 检查登录状态
     * @param {Function} callback
     */
  checkLogin (callback) {
    const _params = { client: 'pc' }
    if (callback instanceof Function) {
      cacheCheckLoginQueue.push(callback)
    }
    if (userInfo && this.isLogin() && callback instanceof Function) {
      callback(this.isLoginStatus, userInfo)
      return
    } else if (this.checkLoginStatus) {
      cacheCheckLoginQueue.push(callback)
      return
    }
    this.checkLoginStatus = true
    reqwest({
      url: ApiConfig.useUrl,
      data: _params,
      type: 'jsonp'
    })
      .then((res) => {
        this.checkLoginStatus = false
        if (res.error === 0) {
          this.isLoginStatus = true
          userInfo = res.data
          while (cacheCheckLoginQueue.length) {
            cacheCheckLoginQueue.shift()(this.isLoginStatus, userInfo)
          }
          cacheCheckLoginQueue = []
        } else {
          this.isLoginStatus = false
          if (res.info === 'VERIFYCOOKIE_API_RETURN_FALSE') {
            // 发送黄金令箭
          }

          if ((res.info === 'EMPTY_TOKEN' || res.info === 'VERIFYCOOKIE_API_RETURN_FALSE') && this.isLogin()) {
            Cookie('P_gck', 0, { expires: -1, domain: 'youku.com', path: '/' })
          }
        }
      })
  },

  /**
     * 登录成功回调
     */
  loginSuccess () {
    this.isLoginStatus = true
    this.checkLogin()
    if (loginSuccessQueue.length > 0) {
      loginSuccessQueue.forEach((item, index) => {
        if (item instanceof Function) {
          item()
        }
      })
    }
    loginSuccessQueue = []
  },
  logoutSuccess () {
    userInfo = null
  },

  Xlogin (opts) {
    opts = opts || {}
    opts = Object.assign(opts, DefaultLoginOptions)

    opts.loginSuccess = () => { // 登陆成功，同步登录成功，注册成功的调用函数。
      if (this._loginInsatance && this._loginInsatance.closeFrame) {
        this._loginInsatance.closeFrame()
      }
      this.loginSuccess()
    }

    // 检查是否是登录的
    opts.checkNoLogin = (res) => {
      console.log(res)
    }

    // 加载成功之后，设置登录框背景图
    opts.loadSucess = () => {
      this.setLoginBg()
    }

    this._loginInsatance = window.Xlogin = new window.YKLoginLoader(opts)
  },

  /**
     * 获取登录框配置并设置登录框背景图
     */
  setLoginBg () {
    reqwest({
      url: '//cmstool.youku.com/cms/tool/pub/get_putdata.json?securemode=2&callback=?',
      type: 'jsonp',
      data: { client: 'pc' }
    }).then((res) => {
      if (res.e.code === 0) {
        if (res.data.loginpic.daytimepic) ThemeConfig.daytimeBgURL = res.data.loginpic.daytimepic
        if (res.data.loginpic.eveningpic) ThemeConfig.eveningBgURL = res.data.loginpic.eveningpic
        const nowHours = (new Date()).getHours()
        const isEvening = (nowHours >= 18 || nowHours <= 8)
        const bgThemes = '#fff url(' + (isEvening ? ThemeConfig.eveningBgURL : ThemeConfig.daytimeBgURL) + ') no-repeat right bottom'
        if (window.YKLoginLoader && window.YKLoginLoader.getInstance()) {
          window.YKLoginLoader.getInstance().updateThemeBg(bgThemes)
        }
      }
    })
  },

  login (opts, callback) {
    opts = opts || {}
    if (opts instanceof Function) {
      callback = opts
      opts = {}
    }
    if (this.isLogin()) {
      callback && callback()
      this.loginSuccess()
      return
    }
    // 是否是注册
    if (opts.regist) {
      this._loginInsatance.buildRegDom()
    } else {
      this._loginInsatance.buildLoginDom()
    }
  },

  logout () {
    if (typeof window !== 'undefined') {
      const _logout = new window.YKLoginLoader({
        loginOrLogout: 'logout',
        buid: DefaultLoginOptions.buid,
        pid: DefaultLoginOptions.pid,
        logoutSuccess: () => {
          this.logoutSuccess()
          window.location.reload()
        }
      })
      return _logout
    }
  },

  on (event, handler) {
    let queue = null
    switch (event) {
      case Events.LOGIN_SUCCESS: {
        queue = loginSuccessQueue
        break
      }
      case Events.LOGIN_OUT: {
        queue = logoutSuccessQueue
        break
      }
      case Events.CHECK_LOGIN: {
        queue = logoutSuccessQueue
        break
      }
      default:
    }
    if (!checkhandle(queue, handler)) {
      queue.push(handler)
    }
  },

  fire (events, handle) {

  },

  trigger (events) {

  }
}
if (__isBrowser__) {
  Login.init()
  Login.Events = Events
  window.XLogin = {
    login: () => {
      return Login.login()
    },
    logout: () => {
      return Login.logout()
    },
    isLogin: () => {
      return Login.isLogin()
    },
    getUserInfo: () => {
      return userInfo
    },
    on: (event, handler) => {
      Login.on(event, handler)
    }
  }
}
export default Login
